import * as Turbo from '@hotwired/turbo';

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

const application = Application.start();
const context = require.context('./stimulus_controllers', true, /\.js$/);
application.load(definitionsFromContext(context));

// To get better diagnosis from Stimulus turn this on /JK
////application.debug = true;
